module.exports = __webpack_public_path__ + "img/master.35b58b76.png";